import { render, staticRenderFns } from "./IncludeEmailsTable.vue?vue&type=template&id=36bfb499&scoped=true"
import script from "./IncludeEmailsTable.vue?vue&type=script&lang=js"
export * from "./IncludeEmailsTable.vue?vue&type=script&lang=js"
import style0 from "./IncludeEmailsTable.vue?vue&type=style&index=0&id=36bfb499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bfb499",
  null
  
)

export default component.exports